/* eslint-disable react/prop-types */
import React, { useState } from "react";
import SoftBox from "components/SoftBox";
import DataTable from "examples/Tables/DataTable";
import { Box, Chip, colors } from "@mui/material";
import { useSoftUIController } from "context";
import SoftTypography from "components/SoftTypography";
import borders from "assets/theme/base/borders";

const getStatusChip = (status) => {
  const isConfirmed = status.toLowerCase() === "confirmed";
  return (
    <Chip
      label={status}
      size="small"
      sx={{
        backgroundColor: isConfirmed ? "#d1fae5" : "#fee2e2",
        color: isConfirmed ? "#065f46" : "#991b1b",
        fontWeight: "bold",
        fontSize: "0.75rem",
        
      }}
    />
  );
};

// Styled Cell Renderer
const BoldGreyCell = ({ children }) => (
  <SoftTypography
    variant="body2"
    fontWeight="bold"
    color="dark"
    sx={{ fontSize: "0.875rem" }}
  >
    {children}
  </SoftTypography>
);
// Column definitions
const columns = [
  { Header: "Date", accessor: "date", align: "left",},
  { Header: "Request", accessor: "request", align: "center" },
  { Header: "Status", accessor: "status", align: "center" },
];

// Sample rows
const rows = [
  {
    date: "2025-07-21",
    request: "Leave Request (Casual)",
    status: getStatusChip("Confirmed"),
  },
  {
    date: "2025-07-20",
    request: "Early Login Approval",
    status: getStatusChip("Denied"),
  },
  {
    date: "2025-07-19",
    request: "Work From Home Request",
    status: getStatusChip("Confirmed"),
  },
  {
    date: "2025-07-18",
    request: "Shift Change Request",
    status: getStatusChip("Denied"),
  },
  { date: "2025-07-17",
    request: "Leave Request (Sick)",
    status: getStatusChip("Confirmed"),
  },
  { date: "2025-07-16",
    request: "Overtime Approval",
    status: getStatusChip("Confirmed"),
  },
  { date: "2025-07-15",
    request: "Leave Request (Casual)",
    status: getStatusChip("Confirmed"),
  },
];

const PrePaymentTable = () => {
//   const [controller] = useSoftUIController();
//   const { miniSidenav } = controller;
//   const sidenavWidth = miniSidenav ? 100 : 260;

  return (
    <Box
    //   sx={{
    //     ml: `${sidenavWidth}px`,
    //     width: `calc(100% - ${sidenavWidth}px)`,
    //     transition: "margin-left 0.3s ease, width 0.3s ease",
    //     px: { xs: 2, md: 3 },
    //     pb: 4,
        
    //   }}
    >
      <SoftBox px={3} pb={5} mt={5} mr={3}>
        <Box
          sx={{
            "& table": {
              borderCollapse: "collapse",            },
            "& th, & td": {
              borderRight: "1px solid #e0e0e0",
            },
            "& th:last-child, & td:last-child": {
              borderRight: "none",
            },
            border: "1px solid #e0e0e0",
           boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
          }}
        >
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
        </Box>
      </SoftBox>
    </Box>
  );
};

export default PrePaymentTable;
